import { ProgressBar } from "react-bootstrap";
import ImageComponent from "../Layouts/ImageComponent";
import ProviderComponent from "../Layouts/ProviderComponent";
import {
  FreeForYou,
  FreePaidSubscription,
  PriceAt,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  clickStreamUser,
  convertTimeFormat,
  getPriceInfoForEntity,
  getProcureInfo,
  redirectToPageUtil,
} from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssignBrokerCourse,
  getAssignBrokerCourseClear,
  getAssignCourse,
  getAssignCourseClear,
} from "../../redux/courses/actions";
import _ from "lodash";
// import {recommendationInsertViewData} from "../../redux/recommendationView"
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import CONFIG from "../../utils/config";
import moment from "moment";
import { courseDetailResponse } from "../../redux/product/actions";
import ErrorSection from "../ErrorPage/ErrorSection";
import InfiniteScroll from "react-infinite-scroll-component";
import useLogin from "../../custom-hooks/useLogin";
import NotFoundComponent from "../NewDesign/NotFound/NotFoundComponent";
import { useTranslation } from "react-i18next";

const CourseCardOneB2C = (props) => {
  const {
    arrList,
    newCardData,
    setNewCardData,
    setHasNoMore,
    total_records,
    paginateCB,
    setIsFetching,
    pageNum,
    setCourseCount,
    apiListing,
    setApiListing,
    tabKey,
    isCombo,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useLogin();
  // CONFIG.INITIAL_PRODUCT_CARD_DATA
  const authBroker = useSelector((state) => state.auth.authBroker);
  const assignCourse = useSelector((state) => state.courses.assignCourse);
  const assignBrokerCourse = useSelector(
    (state) => state.courses.assignBrokerCourse
  );
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

  const [courseData, setCourseData] = useState({});
  const { t } = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let provider_id = "";
  let provider_name = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    provider_id = paramsReq.provider_id;
    provider_name = paramsReq.provider_name;
  }

  const setCourseDetailData = (course) => {
    let startOffer = moment(course["start_date_&_time_of_offer"], "YYYY-MM-DD");
    let endOffer = moment(course["end_date_&_time_of_offer"], "YYYY-MM-DD");
    let tempObj = {
      payload: {
        course_code: course.crscd,
        course_discount: course.discount,
        course_duration: course.duration,
        course_lessons: course.lessons,
        course_period: course.durationUnit,
        course_views: course.views,
        product_description: course.long_description,
        product_id: course.id,
        product_name: course.name,
        product_price: course.market_price,
        product_regular_price: course.market_price,
        product_sale_price: course.selling_price,
        product_short_description: course.short_description,
        product_slug: course.name,
        product_thumbnail: course.imageURL,
        product_total_sales: course.market_price,
        sfdc_product_type: course.sfdc_product_type,
        course_list: _.isArray(course.course_list) ? course.course_list : [],
        product_basic_price: course.product_basic_price,
        product_premium_price: course.product_premium_price,
        product_offer_for_basic: course.product_offer_for_basic,
        product_offer_for_premium: course.product_offer_for_premium,
        start_date_time_of_offer: course["start_date_&_time_of_offer"],
        end_date_time_of_offer: course["end_date_&_time_of_offer"],
        offer_available: moment().isBetween(startOffer, endOffer),
      },
      status: "success",
    };
    dispatch(courseDetailResponse(tempObj));
  };
  const redirectToPage = (course) => {
    console.log("course", course);

    // console.log("course 2");
    if (course?.source === "ecom" && !course?.is_paid) {
      // setCourseDetailData(course);
      let url = `/moduleDetail/${course?.crscd}/?source=${course?.source}&cid=${
        course.id ? course.id : course?.wc_post_id
      }&price=${course.priceInfo.price}&is_paid=false`;
      navigate(url);
      // navigate(`/shopping/${course.id}/?addToCart=${course?.is_addtocart}`);
    } else if (
      course?.is_paid === "" ||
      course?.is_paid === undefined ||
      course?.is_paid
    ) {
      // console.log("course 4");
      clickStreamUser("course_card_click_goto_course", {
        courseId: course?.id,
        courseName: course?.name,
        userId: authBroker?.payload?.user.user_id,
        courseCode: course?.crscd,
      });
      if (course?.source === "broker") {
        setCourseData(course);
        // console.log("course redirect to module");
        // dispatch(
        //   getAssignBrokerCourse({
        //     module: "assignedCourseBroker",
        //     postData: {
        //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //       entity_type: "courses",
        //       entity_id: course?.wc_post_id
        //         ? _.toNumber(course?.wc_post_id)
        //         : course?.id,
        //       origin: "broker",
        //       $number_of_days: "",
        //       is_type: "free",
        //     },
        //   })
        // );

        // console.log("course 5");
        // navigate(
        //   `/moduleDetail/${course?.crscd}/?source=${course?.source}`
        // );
        goToModuleDetail(course);
      } else {
        // console.log("course redirect to assign", course);

        setCourseData(course);
        // if (isLoggedIn) {

        //   dispatch(
        //     getAssignCourse({
        //       module: "assign-course",
        //       postData: {
        //         user_id: authBroker?.payload?.user.user_id,
        //         course_id: course?.crscd,
        //       },
        //     })
        //   );
        //   dispatch(
        //     getAssignBrokerCourse({
        //       module: "assignedCourseBroker",
        //       postData: {
        //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //         entity_type: "courses",
        //         entity_id: course?.crscd,
        //         origin: "xsel",
        //         number_of_days: course?.course_days,
        //         is_type: course?.is_free ? "free" : "paid",
        //         comment: course?.name,
        //       },
        //     })
        //   );
        // } else {
        // }
        goToModuleDetail(course);
      }
    }
  };

  const goToModuleDetail = (courseData) => {
    let paramsReq = {
      source: courseData?.source,
      cid: courseData.id ? courseData.id : courseData?.wc_post_id,
      is_paid: "true",
    };
    if (courseData.course_categoryId) {
      paramsReq.catId = courseData.course_categoryId;
      paramsReq.via_cat = "true";
    } else if (courseData.isLevel) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.is_level = "true";
      paramsReq.level_id = courseData.level_id;
    } else if (courseData.lp_id) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.via_lp = "true";
    }
    if (provider_id) {
      paramsReq.provider_id = provider_id;
      paramsReq.provider_name = provider_name;
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/moduleDetail/${courseData?.crscd}/?c=${encodedUrl}`;

    // let url = `/moduleDetail/${courseData?.crscd}/?source=${
    //   courseData?.source
    // }&cid=${
    //   courseData.id ? courseData.id : courseData?.wc_post_id
    // }&is_paid=true`;

    // if (courseData.course_categoryId) {
    //   url = url + `&catId=${courseData.course_categoryId}&via_cat=true`;
    // } else if (courseData.isLevel) {
    //   url =
    //     url +
    //     `&lp_id=${courseData.lp_id}&via_lp=true&is_level=true&level_id=${courseData.level_id}`;
    // } else if (courseData.lp_id) {
    //   url = url + `&lp_id=${courseData.lp_id}&via_lp=true`;
    // }
    // sessionStorage.setItem("moduleForTour", url);
    navigate(url);
  };

  useEffect(() => {
    // console.log("assignCourse", assignCourse, courseData);
    if (assignCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignCourseClear());
      goToModuleDetail(courseData);
    }
  }, [assignCourse, courseData]);

  useEffect(() => {
    if (assignBrokerCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignBrokerCourseClear());
    }
  }, [assignBrokerCourse]);

  const footerClicked = (course) => {
    console.log(course);
  };
  const bannerClicked = (course) => {
    console.log(course);
  };
  const footerLineRender = (course) => {
    return <span className="signup-btn">Included with paid subscriptions</span>;
  };

  useEffect(() => {
    if (!_.isEmpty(arrList)) {
      let prodArr = [];
      for (let [index, course] of arrList.entries()) {
        let tags = [];
        let btnTitle = t("Start course");
        if (course.provider?.provider_display_name) {
          tags.push(course.provider.provider_display_name);
        }
        if (course.product_type === "learningpath") {
          tags.push(t("Action Path"));
        }
        if (course.product_type === "bundle") {
          tags.push(t("Combo"));
        }
        if (
          course.product_type === "bundle" ||
          course.product_type === "learningpath"
        ) {
          if (course.learningpath_count > 0) {
            tags.push(
              `${course.learningpath_count} ${t("Action Path")}${
                course.learningpath_count > 1 ? "s" : ""
              }`
            );
          }
          if (course.course_count > 0)
            tags.push(
              `${course.course_count} ${t("Course")}${
                course.course_count > 1 ? "s" : ""
              }`
            );
          if (course.video_count > 0)
            tags.push(
              `${course.video_count} ${t("Video")}${course.video_count > 1 ? "s" : ""}`
            );
          if (course.event_count > 0)
            tags.push(
              `${course.event_count} ${t("Event")}${course.event_count > 1 ? "s" : ""}`
            );
        } else if (course.product_type === "video") {
          tags.push(t("Video"));
          tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
        } else if (course.product_type === "service") {
          tags.push(t("coaching"));
          tags.push(
            _.toLower(course?.payment_frequency) === "monthly"
              ? t("Subscription")
              : t("One Time")
          );
        } else {
          tags.push(t("Course"));
          if (course.lessons) {
            tags.push(
              `${course.lessons} ${t("Module")}${course.lessons > 1 ? "s" : ""}`
            );
          }
        }

        if (course.duration) {
          tags.push(`${course.duration}`);
        }

        if (
          (course?.source === "ecom" || course?.source === "xsel") &&
          !course?.purchased_info?.is_purchased &&
          course?.purchased_info?.selling_price != 0
        ) {
          btnTitle = t("Explore");
        } else if (
          course.crs_progress === "" ||
          course.crs_progress === undefined ||
          course.crs_progress === null ||
          course.crs_progress === 0
        ) {
          btnTitle = t("Start course");
        } else if (course.crs_progress > 0 && course.crs_progress < 100) {
          btnTitle = t("Resume course");
        } else if (course.crs_progress >= 100) {
          btnTitle = t("Revisit course");
        }

        let priceInfo = getProcureInfo(course.purchased_info);
        course.priceInfo = priceInfo;
        course.isLoggedIn = isLoggedIn;

        if (provider_id) {
          course.provider_id = provider_id;
          course.provider_name = provider_name;
        }

        prodArr.push({
          id: course?.id,
          ecom_id: course?.ecom_id ? course?.ecom_id : course?.wc_post_id,
          is_like: course?.is_like ? course?.is_like : false,
          is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
          is_wishlist: course?.is_addtowishlist,
          dbId: course?.list_id,
          productType: course?.product_type,
          productOrigin: course?.origin,
          title: course.name,
          logoURL: course.provider?.provider_img
            ? course.provider?.provider_img
            : "",
          bannerURL: course.imageURL,
          tagsArray: tags,
          description: course.short_description,
          btnTitle: btnTitle,
          progress: course.crs_progress,
          isLoggedIn: isLoggedIn,
          btnAction: () =>
            redirectToPageUtil(
              course,
              navigate,
              authBroker,
              setCourseData,
              dispatch,
              tabKey === "combo" ? "bundle" : "course"
            ),
          descAction: {},
          bannerAction: () =>
            redirectToPageUtil(
              course,
              navigate,
              authBroker,
              setCourseData,
              dispatch
            ),
          footerLineComp: !_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : "",
          showHeader: true,
          showProviderIcon: true,
          showLikeMenu: true,
          showBody: course.short_description ? true : false,
          showFooter: true,
          showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",
          updatedAt:
            course?.product_type === "service" ? "" : course?.created_dt,
          priceInfo,
          isBundle: course?.product_type === "bundle",
          bundles: course?.bundles,
          status: course?.crs_status,
        });
      }
      // console.log('PROD ARR', prodArr)
      // let newCardDataTemp = [...apiListing, ...prodArr]
      // setNewCardData(newCardDataTemp)
      // setApiListing(newCardDataTemp)

      let newProdArr = prodArr;
      if (pageNum > 1) {
        newProdArr = [...apiListing, ...prodArr];
        console.log(newProdArr);
        setNewCardData(newProdArr);
        setApiListing(newProdArr);
        setIsFetching(false);
      } else {
        setNewCardData(prodArr);
        setApiListing(prodArr);
      }

      // setCourseCount(newProdArr.length);
      console.log("recordsLength: ", total_records);
      if (total_records === newProdArr.length) {
        setIsFetching(false);
        setHasNoMore(true);
      } else {
        setHasNoMore(false);
      }
    } else {
      setNewCardData([]);
    }
  }, [arrList]);

  return (
    <>
      <div className="row coursecard-row videosection-cont">
        {newCardData.length === 0 ? (
          //  isCombo ?
          <NotFoundComponent showMsg={true} />
        ) : (
          //  : <ErrorSection />
          newCardData.map((course, i) => {
            return (
              <ProductCardComponent
                {...course}
                key={`course-${i + 1}`}
                lastKey={newCardData.length === i + 1}
                refInfo={paginateCB}
              />
            );
          })
        )}
      </div>
    </>
  );
};
export default CourseCardOneB2C;
